// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"457":"413b4b1e","1077":"920e4642","5368":"413b4b1e","6112":"52bf8a6e","9751":"15461fc3"}[chunkId] + ".chunk.css";
};